import MintFigureView from "./MintFigureView/MintFigureView.js";
import { 
  EquipmentContainer,
  EquipmentContainerInner,
  EquipmentContainerMobile,
  EquipmentRoot,
  Header,
  Scene,
  Spacer,
  TitleContainer,
  Delimiter,
  Weapons,
  Basejump,
  IncubationSystem,
  TitleLine
} from "./MintEquipment.styled.js";
import FigureModel from "../../models/FigureModel.js";
import WidgetFrame from "../WidgetFrame/WidgetFrame.js";
import useIsMobile from '../../hooks/useIsMobile';
import { useState, useRef, useEffect } from 'react';
import { HYPEROBJECT_WHITEPAPER_URL } from '../../constants';

const MINT_MODELS = [
  {
    id: 'STAGE 03',
    name: 'Full',
    vrm: '/assets/full_avatar.vrm',
    glb: '/assets/full_avatar.vrm',
    image: '/assets/full_avatar.png'
  }
];

export default function MintEquipment() { 
  const isMobile = useIsMobile();
  const figures = MINT_MODELS.map((f) => FigureModel.fromAlchemyNft(f));
  const controls = {};
  const [sceneHeight, setSceneHeight] = useState('100%');
  const equipmentRef = useRef(null);

  useEffect(() => {
    const onResize = () => {
      if (equipmentRef.current) {
        const rect = equipmentRef.current.getBoundingClientRect();
        setSceneHeight(`${rect.height}px`);
      }
    };
    
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <EquipmentRoot>
      {isMobile ? (
        <EquipmentContainerMobile>
          <Header>
            <Basejump src="/assets/basejump_logo.svg"/>
            <IncubationSystem><b>$ACTION </b>AI GAMING SUBSTRATE</IncubationSystem>
          </Header>
          <TitleLine>
            Using the Basejump cutting edge <b>$ACTION AI GAMING SUBSTRATE</b>™
            you can upgrade $ACTION Figures, forge them into unique warriors,
            and equip them with <b>$ACTION</b> ITEMS to further their mission.
          </TitleLine>
          <Weapons src="/assets/weapons.gif"/>
          <Delimiter />
        </EquipmentContainerMobile>
      ) : (
        <EquipmentContainer>
          <EquipmentContainerInner ref={equipmentRef}>
          <Header>
            <Basejump src="/assets/basejump_logo.svg"/>
            <IncubationSystem></IncubationSystem>
          </Header>
          <TitleContainer>
            <Spacer />
	    <TitleLine>
	      Basejump is powered by ACTION, an infinitely scalable, open AI game engine that lets you make next-gen games and assets known as HYPEROBJECTS. <a href={HYPEROBJECT_WHITEPAPER_URL} target='_blank' rel='noreferrer'><b>Read the ACTION whitepaper to learn more.</b></a>
            </TitleLine>
          </TitleContainer>
          <Weapons src="/assets/weapons.gif"/>
          <Delimiter />
          </EquipmentContainerInner>
        </EquipmentContainer>
      )}
      <Scene $isMobile={isMobile}>
        <WidgetFrame color={'transparent'}>
          <MintFigureView controls={controls}
            figure={figures[0]}
            noDecorators
            width='100%'
            height='100%'
            maxHeight={sceneHeight}
          />
        </WidgetFrame>
        {isMobile && <div style={{ gridColumn: 1, gridRow: 1, position: "relative" }} />}
      </Scene>
    </EquipmentRoot>
  )
}
